import util from '@bmp-vue/core/api/util'

const controller = 'Carteiras'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {})
